import BotConditionCard from "./BotConditionCard";
import React from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormChipInput from "../../input/ReactHookFormChipInput";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import {Box, Button, IconButton} from "@mui/material";
import {Add, Delete} from "@mui/icons-material";

function BotConditionIP(props) {
    const {control, setValue, getValues} = props;

    // Watch rules object in real-time
    const rules = useWatch({control, name: "rules"}) || {};
    const ipData = rules?.ip;
    const hasIpCondition = !!ipData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
    ];

    // REMOVE: Safe JS delete approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules.ip;
        setValue("rules", currentRules);
    };

    // ADD: Initialize flat ip object (Note: IP usually skips includeEmptyValue)
    const addCondition = () => {
        setValue("rules.ip", {
            condition: "is",
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasIpCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>IP</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label="condition"
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasIpCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            IP
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="remove"
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name="rules.ip.condition"
                            label="conditions"
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <ReactHookFormChipInput
                            control={control}
                            name="rules.ip.values"
                            label="IP"
                        />
                    </Box>
                    <Box>
                        <Box
                            component="p"
                            sx={{
                                fontSize: 12,
                                color: 'text.noticeDark',
                                pt: 1.5,
                                m: 0
                            }}
                        >
                            *Supported formats are IPv4, IPv6 and ranges. IP range: 192.168.0.1-192.168.0.255
                        </Box>
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}

export default BotConditionIP;
